// Central place for the Next Billion brand mark.
// Uses the local /icons/nb-logo.png (regenerated Feb-20 with tight crop of user's latest logo).

export const NB_LOGO_URL = "/icons/nb-logo.png";

export function BrandMark({ size = 40, className = "", withGlow = true }) {
  return (
    <div className={`relative inline-flex items-center justify-center shrink-0 ${className}`} style={{ width: size, height: size }}>
      {withGlow && (
        <div
          aria-hidden
          className="absolute inset-0 rounded-full blur-md opacity-40"
          style={{ background: "radial-gradient(circle, rgba(138,226,52,0.6), transparent 70%)" }}
        />
      )}
      <img
        src={NB_LOGO_URL}
        alt="Next Billion"
        width={size}
        height={size}
        className="relative rounded-full object-cover"
        style={{ width: size, height: size, boxShadow: "0 4px 18px rgba(0, 229, 255, 0.25)" }}
        loading="eager"
      />
    </div>
  );
}

export function BrandLockup({ size = 40, tagline = true, dark = true }) {
  return (
    <div className="flex items-center gap-3 min-w-0">
      <BrandMark size={size}/>
      <div className="leading-tight min-w-0">
        <div className={`font-heading font-bold whitespace-nowrap ${dark ? "text-white" : "text-black"}`} style={{ fontSize: Math.max(14, size * 0.42) }}>
          Next Billion
        </div>
        {tagline && (
          <div className="hidden sm:block text-[10px] tracking-widest uppercase whitespace-nowrap" style={{ color: "#00E5FF" }}>
            Next Vision · Next Level
          </div>
        )}
      </div>
    </div>
  );
}
